<ion-content>
  <ion-searchbar placeholder="Suchen..." [(ngModel)]="searchText" (ngModelChange)="search()" (keyup.enter)="select()"></ion-searchbar>
  <ion-list>
    <ion-item (click)="allSelect()" *ngIf="searchText == ''">
      <ion-checkbox slot="start" [(ngModel)]="selectedAll" labelPlacement="end">
        Alle
      </ion-checkbox>
    </ion-item>
    <ion-item *ngFor="let user of employeeFilter" (click)="uncheckAll()">
      <ion-checkbox slot="start" [(ngModel)]="user.checked" labelPlacement="end">{{user?.firstName}} {{user?.lastName}}</ion-checkbox>
    </ion-item>
  </ion-list>
</ion-content>